export default "__VITE_ASSET__c$oNWZ2___"